module.exports = __webpack_public_path__ + "images/document-323305e4ea1244392ab7defae4711a58.svg";